import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ShortcutButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  label: string;
}

const ShortcutButton = ({ icon, label, ...props }: ShortcutButtonProps) => {
  return (
    <button type="button" className="shortcut-button" {...props}>
      {icon && <span className="shortcut-button__icon">{icon}</span>}
      <span>{label}</span>
    </button>
  );
};

export default ShortcutButton;
